window.dtSystemUser = function () {
  const dtSystemUser = new DataTable('#system-user-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#system-user-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#system-user-datatable', 3); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, "asc"]],
    columns: [
      { data: "index" },
      { data: "status" },
      { data: "email" }
    ],
    language: {
      search: " ",
      sLengthMenu: "_MENU_",
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row) {
      $("td", row).addClass("py-1");
    }
  });

  dtFinalTouch();
}
